export const TaxonomyActions={
    SAVE_CITIES:"SAVE_CITIES",
    SAVE_LANGUAGES:"SAVE_LANGUAGES",
    SAVE_STATES:"SAVE_STATES"
}